export default __webpack_public_path__ + "static/media/fixed-com1.d8a9471c.jpeg";